import React, { useEffect, useState } from 'react';
import { Button, Input } from 'components';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  passwordInfoSelector,
  updatePasswordInfoField,
} from 'redux/slices/profile/UserInfoSlice';

const PasswordInfoForm = () => {
  const dispatch = useDispatch();
  const passwordInfo = useSelector(passwordInfoSelector);

  const { formState, setValue } = useFormContext();
  const { errors } = formState;

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    setValue('password1', passwordInfo?.password1);
    setValue('password2', passwordInfo?.password2);
  }, [passwordInfo]);

  const handleChangePasswordInfo = (field, value) => {
    dispatch(updatePasswordInfoField({ field, value }));
  };
  useEffect(() => setFormErrors({ ...errors }), [errors]);

  return (
    <>
      <div
        className="text-large text-primary font-bold  text-center 
      "
      >
        Şifre Bilgileri
      </div>
      <div className="w-96">
        <div className="p-4">
          <Input
            maxLength={64}
            required
            label="Yeni Şifre"
            isTextVisible={false}
            name="password1"
            id="password1"
            type="password"
            value={passwordInfo.password1}
            onChange={(e) =>
              handleChangePasswordInfo(e.target.name, e.target.value)
            }
            errors={formErrors?.password1?.message}
          />
        </div>
        <div className="p-4">
          <Input
            required
            label="Şifreni Onayla"
            name="password2"
            isTextVisible={false}
            id="password2"
            type="password"
            value={passwordInfo.password2}
            onChange={(e) =>
              handleChangePasswordInfo(e.target.name, e.target.value)
            }
            errors={formErrors?.password2?.message}
          />
        </div>
      </div>
      <Button
        className=" bg-primary "
        buttonTextClass="text-white"
        text="Kaydet"
        type="submit"
      />
    </>
  );
};

export default PasswordInfoForm;
